<template>
  <O3D><slot></slot></O3D>
</template>

<script>
// import { WoozyMaterial } from '../../Reusable/WoozyMaterial'
import { O3DG2 } from '../../Reusable/O3DG2'
import { ShaderCubeRefraction } from '../../Reusable/ShaderCubeRefraction'
import { loadGLTF } from '../../Reusable/loadGLTF'
import { Color, DoubleSide } from 'three'

export default {
  mixins: [O3DG2],
  props: {
    envMap: {}
  },
  methods: {
    async setup () {
      let url = require('file-loader!./glb/spaceship.glb')
      let shaderCube = new ShaderCubeRefraction({ renderer: this.ctx.renderer, loop: this.onLoop, res: 50, color: new Color('#ffffff') })
      // let woozy = new WoozyMaterial()
      // woozy.tCube = shaderCube.out.envMap

      loadGLTF(url).then(async (gltf) => {
        let scene = gltf.scene
        scene.traverse((item) => {
          if (item.isMesh) {
            // console.log(item.name)
            item.material =  shaderCube.out.material
            item.material.side = DoubleSide
          }
        })

        let scale = 1
        scene.scale.x = scale
        scene.scale.y = scale
        scene.scale.z = scale

        this.onLoop(() => {
          scene.rotation.x += 0.003
        })
        this.o3d.add(scene)
      })
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>